const defaultCampaignInfluencers = [
  "Semantic Search",
  "Color",
  "Attributes",
  "Price",
  "Category",
];

const vpsCampaignInfluencers = defaultCampaignInfluencers.filter(
  (value) => !["Price", "Category"].includes(value),
);

export const allowedInfluencers = {
  VPS: vpsCampaignInfluencers,
  VPR: defaultCampaignInfluencers,
  VPC: defaultCampaignInfluencers,
  VPD: [] as string[],
  TEXT_SEARCH: vpsCampaignInfluencers,
};
